import { Box } from '@mui/material'
import { FC, PropsWithChildren } from 'react'

export interface MainContentBodyProps extends PropsWithChildren {}

export const MainContentBody: FC<MainContentBodyProps> = ({ children }) => {
  return (
    <Box
      sx={{
        flex: 1,
        overflowY: 'auto',
        padding: '24px',
        backgroundColor: '#fafafa',
      }}
    >
      {children}
    </Box>
  )
}
